import React, {useEffect, useState} from "react";
import BottomActionBar from "./BottomActionBar";

const ayurvedicProducts = [
    { name: "Face cream Link", price: "3.1€" },
    { name: "Alo Vera", price: "M 1.66€ , L  3.33€" },
    { name: "Chavikanthi", price: "0.96€" },
    { name: "Sujatha", price: "1.1€" },
    { name: "Medahara Vati", price: "3.25€" },
    { name: "Gokshuradi vati", price: "3.8€" },
    { name: "Shathavari capsule 💊", price: "4€" },
    { name: "Ashwagandha capsule 💊", price: "2.7€" },
    { name: "Ashwagandha rasayanam", price: "1.5€ (packet), 4.6€ (bottle)" },
    { name: "Sukumara churnam", price: "1€" },
    { name: "Slimin capsule 💊", price: "3.25€" },
    { name: "Thripala tablet ", price: "3.3€  ( L bottle) , 2.2€ ( M bottle)" },
    { name: "Morinnga capsule 💊", price: "3.3€" },
    { name: "Sarpagahandha vati", price: "4€" },
    { name: "Brahmee vati", price: "3€" },
    { name: "Sudharshana vati", price: "3.36€ ( M bottle) , 9.83€ ( L bottle)" },
    { name: "Karavila vati", price: "3.3€" },
    { name: "Rasnadee vati", price: "6.66€" },
    { name: "Kaishora vati", price: "6.66€" },
    { name: "Curcumin", price: "4€" },
    { name: "Lekhaneeya vati", price: "2.33€" },
    { name: "Nidisuwaya vati", price: "1.4€" },
    { name: "Maha marayana oil (180ml)", price: "2.5€ - joints pain" },
    { name: "Shulahara oil (180ml)", price: "2.5€ - joints pain" },
    { name: "Thripala oil (180ml)", price: "2.5€ - body & head massage 💆" },
    { name: "Neelyadi oil (180ml)", price: "2.3€ - body & head massage 💆‍♀️" }
];



const himalayaProducts = [
    { name: "Abana (60s tab)", price: "4.43€" },
    { name: "Cytone (60s tab)", price: "4.43€" },
    { name: "Diabecon (60s tab)", price: "4.72€" },
    { name: "Diabecon Ds (60s tab)", price: "5.61€" },
    { name: "Evecare (30s cap)", price: "4.48€" },
    { name: "Liv 52 (100s tab)", price: "4.96€" },
    { name: "Liv 52 Ds", price: "5.61€" },
    { name: "Mentat", price: "4.72€" },
    { name: "Pilex", price: "4.72€" },
    { name: "Pilex ointment", price: "3.02€" },
    { name: "Reosto (60s tab)", price: "8.19€" },
    { name: "Rumalaya (60s tab)", price: "5.37€" },
    { name: "Rumalaya (gel)", price: "3.02€" },
    { name: "Rumalaya frot (60s tab)", price: "8.19€" },
    { name: "Septilin (60 tab)", price: "5.15€" },
    { name: "Platenza (60s tab)", price: "11.33€" },
    { name: "Bonnison (100ml liquid)", price: "1.46€" },
    { name: "Bersol (60s tab)", price: "5.85€" },
    { name: "Bersol (syrup 100ml)", price: "3.06€" },
    { name: "Clarina (cream)", price: "2.67€" },
    { name: "Confido (60s tab)", price: "4.1€" },
    { name: "Gasex (100s tab)", price: "3.40€" },
    { name: "Geri-fort (100s tab)", price: "5.02€" },
    { name: "Himcocid (suspension 200ml)", price: "2.72€" },
    { name: "Himplasia (30s tab)", price: "5.66€" },
    { name: "Live 52 (syrup 100ml)", price: "2.39€" },
    { name: "Lukol (60s tab)", price: "4.83€" },
    { name: "Menosan (60s tab)", price: "9.35€" },
    { name: "Ophthacare (drop)", price: "2.09€" },
    { name: "Speman (60s tab)", price: "5.51€" },
    { name: "Tentex royal (caps)", price: "59.58€" },
    { name: "V-gel", price: "2.98€" },
    { name: "Hair zone (solution 60ml)", price: "8.01€" }
];

const ProductList = ({ title, products }) => (




    <div className="mb-10">
        <h2 className="text-2xl font-bold mb-4">{title}</h2>
        <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {products.map((item, idx) => (
                <li key={idx} className="bg-white p-4 shadow-md rounded-xl border border-gray-200">
                    <p className="font-medium">{item.name}</p>
                    <p className="text-green-600 font-semibold">{item.price}</p>
                </li>
            ))}
        </ul>
    </div>
);

const OurServices = () => {


    const [showActionBar, setShowActionBar] = useState(true);
    let lastScrollY = window.scrollY;

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            setShowActionBar(currentScrollY < lastScrollY);
            lastScrollY = currentScrollY;
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);



    return (

        <>
            <BottomActionBar visible={showActionBar} />


            <div className="max-w-7xl mx-auto px-4 py-12 bg-gradient-to-b from-green-50 to-white mt-20 lg:mt-16">


                <h1 className="text-4xl font-bold text-center text-green-800 mb-8">Nature's Touch – Ayurveda
                    Products</h1>
                <ProductList title=" Ayurvedic Herbal Medicine Products" products={ayurvedicProducts}/>
                <ProductList title="🌿 Himalaya Herbal Products" products={himalayaProducts}/>
                <div className="bg-white rounded-2xl shadow-lg p-6 border border-yellow-200">
                    <p className="text-center text-3xl text-gray-600">💳 Payment in <strong>Euros</strong> only</p></div>
                <div className="bg-white rounded-2xl shadow-lg p-6 border border-yellow-200 mt-4">
                    <p className="text-center  text-3xl text-gray-600">The Ayurvedic medicines and herbal products you
                        need will
                        be delivered to your hotel as per your request.</p>
                </div>

            </div>
        </>
    );
};

export default OurServices;
